import { ProductSupplierInventoryReceiptDoc } from '@gooduncles/gu-app-schema';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { FC, useMemo } from 'react';

import AgCellProductSupplier from 'src/atomic-components/atoms/AgCell/AgCellProductSupplier';
import AgCellUser from 'src/atomic-components/atoms/AgCell/AgCellUser';

const defaultColDef = {
  sortable: true,
  resizable: true,
  filter: true,
};

interface ProductSupplierInventoryReceiptTableProps {
  rowData: ProductSupplierInventoryReceiptDoc[];
  onRowClick: (row: ProductSupplierInventoryReceiptDoc) => void;
}

const ProductSupplierInventoryReceiptTable: FC<ProductSupplierInventoryReceiptTableProps> = ({
  rowData,
  onRowClick,
}) => {
  const columnDefs: ColDef<ProductSupplierInventoryReceiptDoc>[] = useMemo(
    () => [
      {
        headerName: 'Id',
        field: '_id',
        width: 80,
        hide: true,
      },
      {
        headerName: 'supplierId',
        field: 'supplierId',
        width: 120,
        hide: true,
      },
      {
        headerName: '거래처',
        field: 'name',
        width: 160,
        cellRenderer: AgCellProductSupplier,
        cellRendererParams: (params: any) => ({
          productSupplierId: params.data?.supplierId,
          field: 'name',
        }),
      },
      {
        headerName: '작성자',
        field: 'email',
        width: 240,
        cellRenderer: AgCellUser,
        cellRendererParams: (params: any) => ({
          userId: params.data?.createdBy,
          field: 'email',
        }),
      },
    ],
    []
  );

  return (
    <div className='ag-theme-alpine height100'>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowSelection='single'
        // 행 선택을 켜놓더라도 개별 셀의 내용을 복사할 수 있도록한다.
        enableCellTextSelection={true}
        onSelectionChanged={(e) => {
          onRowClick(e.api.getSelectedRows()[0]);
        }}
      />
    </div>
  );
};

export default ProductSupplierInventoryReceiptTable;
